// extracted by mini-css-extract-plugin
module.exports = {"container":"TransitionSwitch_container__29F5X","page":"TransitionSwitch_page__2-uty"};